import React, {Fragment, useState} from 'react';
import {Icon } from 'semantic-ui-react';
import ImageUpload from './images';
import {Table, Button} from 'react-bootstrap';

const Table2 = (props) => {
  const [edit, setEdit] = useState(false);
  return (
    <Fragment>
        <Table striped bordered hover responsive style={{ width:"90%", margin:"0 auto", marginTop: "8px"}}>
        <thead>
            <tr>
                <th>Label</th>
                <th>Value</th>
                <th>Color</th>
                {props.useImage ?
                <Fragment>
                <th>Image</th>
                <th>Delete</th>
                </Fragment>:
                <th>Delete</th>}
            </tr>
        </thead>
        <tbody>
            {/* <tr>
                    <td><div className="ui input"><input  type="text" id="label" name="label" value=""/></div></td>
                    <td><div className="ui input"><input className="ui input" type="text" id="label" name="label" value=""/></div></td>
                    <td><div className="ui input"><input className="ui input" type="text" id="label" name="label" value=""/></div></td>
                    <td><ImageUpload settingImage={props.settingImage}/></td>
                    <td></td>
                    
            </tr> */}
            {props.data.length > 0 ?
            <Fragment>
            {props.data.map(function(item, i){
            return(<tr key={i}>
                {!edit ? 
                <Fragment>
                <td>{JSON.parse(item).label}</td>
                <td>{JSON.parse(item).value}</td>
                <td>{JSON.parse(item).color}</td>
                {props.useImage ? 
                <Fragment>
                    <td>{JSON.parse(item).image == "" ? "" : <img height="50px" width="50px" src={JSON.parse(item).image} />}</td>
                    <td>
                        {/* <Button className="ui icon button" size='mini' onClick={() => setEdit(!edit)}>
                            <Icon name='edit' />
                        </Button> */}
                        <Button  variant="danger" onClick={() => props.deleteData(item, i)}>
                        Delete
                        </Button>
                    </td> 
                </Fragment>:
                <td>
                    {/* <Button className="ui icon button" size='mini' onClick={() => setEdit(!edit)}>
                        <Icon name='edit' />
                    </Button> */}
                    <Button  variant="danger" onClick={() => props.deleteData(item, i)}>
                       Delete
                    </Button>
                </td>}
                </Fragment>
                 : 
                <Fragment>                                                                                  
                    <td><div className="ui input"><input  type="text" id="label" name="label" value={JSON.parse(item).label}/></div></td>
                    <td><div className="ui input"><input className="ui input" type="text" id="label" name="label" value={JSON.parse(item).value}/></div></td>
                    <td><div className="ui input"><input className="ui input" type="text" id="label" name="label" value={JSON.parse(item).color}/></div></td>
                    <td><img height="50px" width="50px" src={JSON.parse(item).image} /></td>
                    <td></td>
                </Fragment>}
            </tr>) 
            })}
            </Fragment>: ""}
            </tbody>
        </Table>
    </Fragment>
  );
}

export default Table2;